import React from 'react';
import { PropTypes } from 'prop-types';
import mamun from '../../Assets/Img/mamun.png';
import salemir from '../../Assets/Img/salemir.jpeg';
import emdadul from '../../Assets/Img/emdadul.png';

// IMAGE MAPPING
const imageMap = {
  1: mamun,
  3: salemir,
  9: emdadul,
};

const DoctorSlider = ({ doctors }) => {
  // FILTER TO GET SPECIFIC DOCTORS
  const doctorsIdToShow = [1, 3, 9];

  // FILTER TO GET DOCTORS WHOSE IDs ARE IN doctorsIdToShow ARRAY
  const filterDoctors = doctors.filter((doctor) => doctorsIdToShow.includes(doctor.id)).slice(0, 3);

  return (
    <div className="slider-container overflow-hidden relative w-full mb-10">
      <div className="flex animate-slide">
        {filterDoctors.map((doctor) => (
          <div key={doctor.id} className="w-full flex-shrink-0 text-center">
            <img src={imageMap[doctor.id]} alt={`Doctor ${doctor.name}`} className="w-32 rounded-full mx-auto" />
            <h3 className="text-indigo-600 text-lg font-bold">
              ডাঃ
              {' '}
              {doctor.bangla_name}
            </h3>
            <p className="text-gray-600 mt-2">
              {doctor.specialty}
            </p>

            {/* Display chambers */}
            {doctor.chambers && doctor.chambers.length > 0 ? (
              <div className="mt-4">
                <ul className="text-gray-600 text-sm">
                  {doctor.chambers.map((chamber) => (
                    <li key={chamber.id} className="mt-1">
                      <strong>{chamber.name}</strong>
                      ,
                      {chamber.address}
                    </li>
                  ))}
                </ul>
              </div>
            ) : (
              <p className="text-gray-400 text-sm mt-4">No chambers available</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

// PROP VALIDATION
DoctorSlider.propTypes = {
  doctors: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired, // Doctor ID
      name: PropTypes.string.isRequired, // Doctor Name
      bangla_name: PropTypes.string.isRequired, // Doctor Bangla Name
      specialty: PropTypes.string.isRequired, // Specialty
      chambers: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number.isRequired, // Chamber ID
          name: PropTypes.string.isRequired, // Chamber Name
          address: PropTypes.string.isRequired, // Chamber Address
        }),
      ),
    }),
  ).isRequired,
};

export default DoctorSlider;
